module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/text_bg-4f4744d5227e74370c1e4958e9f8bf06.png";